module.exports = __webpack_public_path__ + "img/map-fuel-plan.ed24fe75.svg";